import { graphQlDateTimeToDate } from "common/dates";
import React from "react";

interface Props {
  date: Date | DateTime;
}

export const LocalDate: React.FC<React.PropsWithChildren<Props>> = ({
  date,
}) => {
  const dateObj = date instanceof Date ? date : graphQlDateTimeToDate(date);

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  return (
    <>
      {day}.{month}.{year}
    </>
  );
};
